export const classLevels = [
  {
    id: "elementary",
    tag: "ELEMENTARY",
    name: "초등부",
    headline: "수학의 기초 체력과 자신감을 함께",
    target: "초등 3~6학년",
    desc: "연산의 정확성과 사고력의 균형을 맞추며, 수학을 어렵지 않게 느끼도록 기초 체력을 다지는 과정입니다. 서술형 평가까지 미리 대비해 중등 수학으로 자연스럽게 연결합니다.",
    curriculum: [
      { title: "연산 · 개념 완성", desc: "기본 개념과 연산 정확도를 탄탄히 다집니다." },
      { title: "사고력 · 응용", desc: "문장제와 도형 문제를 통해 사고력을 확장합니다." },
      { title: "서술형 대비", desc: "풀이 과정을 논리적으로 쓰는 습관을 기릅니다." },
    ],
    features: ["주 1회 오답 점검", "개별 진도 맞춤", "학부모 리포트 제공", "소수정예 1:6"],
    image:
      "/uploads/site/mbhj-class-elementary-01.jpg",
  },
  {
    id: "middle",
    tag: "MIDDLE",
    name: "중등부",
    headline: "내신 등급을 올리는 실전력",
    target: "중등 1~3학년",
    desc: "학교 시험 범위에 맞춘 내신 대비와 심화 유형 훈련으로 등급을 끌어올립니다. 중간·기말 전 모의 점검까지 챙겨 시험장에서 실수를 줄이도록 관리합니다.",
    curriculum: [
      { title: "교과 개념 정리", desc: "시험 범위의 핵심 개념을 빠짐없이 정리합니다." },
      { title: "내신 유형 훈련", desc: "학교별 기출과 예상 유형을 집중적으로 연습합니다." },
      { title: "심화 · 고난도", desc: "고득점을 위한 심화 문제까지 단계적으로 다룹니다." },
    ],
    features: ["학교별 내신 분석", "시험 전 모의 점검", "오답 클리닉", "소수정예 1:6"],
    image:
      "/uploads/site/mbhj-class-middle-01.jpg",
  },
  {
    id: "high",
    tag: "HIGH",
    name: "고등부",
    headline: "수능까지 이어지는 탄탄한 개념",
    target: "고등 1~3학년",
    desc: "수Ⅰ·수Ⅱ·미적분의 개념을 탄탄히 세우고, 목표 등급에 맞춰 단계적으로 관리합니다. 모의고사 성취 분석을 통해 취약 단원을 정확히 짚어 보완합니다.",
    curriculum: [
      { title: "개념 완성", desc: "수Ⅰ·수Ⅱ·미적분의 핵심 개념을 체계적으로 세웁니다." },
      { title: "등급별 훈련", desc: "목표 등급에 맞춘 유형별 문제를 반복 훈련합니다." },
      { title: "모의고사 분석", desc: "성취도를 분석해 취약 단원을 집중 보완합니다." },
    ],
    features: ["목표 등급 관리", "수능 기출 분석", "취약 단원 보완", "소수정예 1:6"],
    image:
      "/uploads/site/mbhj-class-high-01.jpg",
  },
];